export const FETCH_LOG_DETAIL_INITIAL = "FETCH_LOG_DETAIL_INITIAL";
export const FETCH_LOG_DETAIL_SUCCESS = "FETCH_LOG_DETAIL_SUCCESS";
export const FETCH_LOG_DETAIL_FAILURE = "FETCH_LOG_DETAIL_FAILURE";
